import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Corporatecabserviceinulubeniriaindustrialpark() {



  const cardData =
  {
    keyword: ' Corporate Cab Service in Uluberia Industrial Park ',
    heading: 'Pune Corporate Cars India Private Limited: Corporate Cab Service in Uluberia Industrial Park ',
    headingDescription: 'Pune Corporate Cars India Private Limited provides professional and reliable Corporate Cab Service in Uluberia Industrial Park, meeting the transportation requirements of manufacturing units, logistics hubs, warehouses, and corporate offices across the region. Our fleet of sedans, SUVs, MUVs, and premium vehicles ensures safe, comfortable, and punctual travel for employees, engineers, supervisors, clients, and senior executives. Whether it is daily office commute, shift-wise transportation, industrial visits, airport transfers, inter-plant movement, business meetings, or VIP travel, we deliver smooth and hassle-free mobility solutions with well-trained chauffeurs, flexible rental plans, and GPS-enabled, well-maintained vehicles, ensuring a premium and dependable corporate transportation experience for businesses operating in and around Uluberia Industrial Park.',

    top: 'Top Places to Visit in Uluberia Industrial Park with Pune Corporate Car',

"topPlaces": [
  {
    "title": "Uluberia Industrial Park Main Zone",
    "description": "The central zone of Uluberia Industrial Park hosts a wide cluster of manufacturing, logistics, and export-oriented industries. With modern infrastructure, wide internal roads, power utilities, drainage, and industrial sheds, the complex is a major growth hub for West Bengal’s industrial expansion. Visitors can observe the organized industrial layout, large production units, and logistics facilities that together showcase the park’s growing economic importance."
  },
  {
    "title": "Shilpa Sadan Administrative Complex",
    "description": "Shilpa Sadan functions as a key administrative and support building for companies operating within the industrial zone. It often hosts business meetings, training sessions, investor support services, and regulatory assistance for new units. The facility plays an important role in the smooth functioning of the industrial ecosystem by connecting government bodies, industries, and development agencies."
  },
  {
    "title": "Uluberia Industrial Technology & Training Centre",
    "description": "This center is dedicated to skills development, industrial training, and technical instruction for young trainees and workers. Equipped with labs, classrooms, equipment, and industry-linked programs, it helps develop a skilled workforce for various industrial roles. The center contributes significantly to employment readiness and supports sustainable industrial growth in the region."
  },
  {
    "title": "Logistics & Warehousing Zone",
    "description": "The logistics and warehousing section features large storage complexes, truck terminals, distribution centers, and transportation service hubs. These facilities streamline supply chain efficiency for incoming raw materials and outgoing finished goods. With smooth connectivity to highways and ports, it serves as a backbone of industrial movement in the area."
  },
  {
    "title": "Green Belt and Utility Corridor",
    "description": "The industrial park includes dedicated landscaped green belts and utility pathways that help maintain environmental balance within a highly active industrial environment. Tree-lined stretches, buffer zones, and planned drainage systems make the area aesthetically planned while supporting pollution control measures. It reflects the park’s commitment to sustainable development."
  },
  {
    "title": "Community Market & Service Area",
    "description": "Located close to the central industrial blocks, this commercial cluster serves workers, staff, and visitors with small eateries, local shops, daily supplies, and service outlets. Always active, it represents the everyday life pulse of the industrial township and provides convenient support for thousands of employees working in the area."
  },
  {
    "title": "Uluberia Industrial Health & Support Center",
    "description": "The health support center provides medical assistance, first-aid facilities, and emergency response for workers and staff on duty. Equipped with healthcare professionals and essential facilities, it ensures that industrial operations are supported by proper occupational safety and health care resources."
  },
  {
    "title": "Business Incubation and Small Enterprise Zone",
    "description": "This zone is dedicated to small and emerging manufacturing and service-based businesses. With shared infrastructure, technology support, and cost-effective industrial spaces, it enables MSMEs and new ventures to grow within a competitive environment. It highlights the industrial park’s objective of nurturing entrepreneurship along with large-scale industry."
  },
  {
    "title": "Regional Office and Support Desk",
    "description": "Located at the entry segment of the industrial complex, the regional office provides support, approvals, licensing services, and investor coordination. It acts as a bridge between the development authority and industries operating within the park, ensuring smooth administrative functioning and fast-track service delivery."
  },
  {
    "title": "Internal Connectivity Road Network",
    "description": "The park features a well-planned network of wide roads, truck bays, loading areas, and connectivity corridors that allow unrestricted movement of industrial machinery, cargo vehicles, and employees. The organized layout helps in minimizing congestion and improving logistics and operational efficiency throughout the park."
  }
],


"services": [
  {
    "name": "Uluberia Industrial Cab",
    "description": "Uluberia Industrial Cab provides reliable corporate transport for employees and executives commuting to Uluberia Industrial Park. Featuring modern sedans, SUVs, and shuttle vehicles, the service ensures timely, safe, and comfortable travel with professional drivers and GPS-enabled monitoring."
  },
  {
    "name": "Corporate Shuttle Uluberia",
    "description": "Corporate Shuttle Uluberia delivers high-capacity shuttle services for large workforce commuting to industrial zones. The service includes optimized routes, AC minibuses, multi-shift support, and real-time tracking to ensure smooth, efficient, and safe staff movement."
  },
  {
    "name": "Employee Transport Uluberia",
    "description": "Employee Transport Uluberia offers structured, daily commute services for corporate and industrial employees. With fixed and flexible routes, trained chauffeurs, and shift-aligned scheduling, it ensures dependable and timely transportation."
  },
  {
    "name": "Staff Pickup Drop Uluberia Industrial Park",
    "description": "Staff Pickup Drop Uluberia Industrial Park provides pre-planned employee pick-up and drop services with GPS tracking, professional drivers, and optimized routes. The service supports multi-shift operations and ensures punctual and safe staff commutes."
  },
  {
    "name": "Monthly Cab Uluberia",
    "description": "Monthly Cab Uluberia offers contract-based corporate transport for daily workforce commuting. The service includes dedicated vehicles, driver management, route optimization, and 24/7 support for uninterrupted and cost-effective operations."
  },
  {
    "name": "Business Cab Uluberia",
    "description": "Business Cab Uluberia delivers premium corporate travel services for client visits, meetings, airport transfers, and executive commuting. Vehicles include sedans and SUVs with trained chauffeurs to ensure comfort, punctuality, and professional service."
  },
  {
    "name": "Affordable Cab Uluberia",
    "description": "Affordable Cab Uluberia provides budget-friendly corporate transport solutions without compromising safety, reliability, or comfort. Ideal for SMEs and mid-sized industrial companies, it includes well-maintained vehicles and skilled drivers."
  },
  {
    "name": "Best Corporate Cab Uluberia",
    "description": "Best Corporate Cab Uluberia offers top-tier corporate mobility with premium vehicles, verified chauffeurs, and superior safety standards. Suitable for executives, managers, and VIP staff requiring a professional travel experience."
  },
  {
    "name": "Outstation Cab Uluberia",
    "description": "Outstation Cab Uluberia provides long-distance corporate travel solutions for intercity client visits, factory tours, and executive trips. It features comfortable sedans and SUVs, trained chauffeurs, route planning, and GPS tracking for safe and convenient travel."
  },
  {
    "name": "Sedan Cab Uluberia",
    "description": "Sedan Cab Uluberia offers executive sedans for managerial commute, airport transfers, and business travel. Each vehicle is well-maintained, with plush interiors and professional drivers ensuring a smooth and comfortable ride."
  },
  {
    "name": "SUV Cab Uluberia",
    "description": "SUV Cab Uluberia provides spacious, high-comfort SUVs for team travel, senior executives, and outstation trips. Equipped with trained drivers and advanced safety monitoring, it ensures a premium corporate travel experience."
  },
  {
    "name": "Company Transport Uluberia",
    "description": "Company Transport Uluberia offers end-to-end corporate transportation services including employee commute, executive travel, and visitor mobility. The service includes fleet management, maintenance, and professional driver operations tailored to industrial companies."
  },
  {
    "name": "Employee Mobility Uluberia",
    "description": "Employee Mobility Uluberia delivers flexible, tech-enabled solutions for workforce commuting. Features include GPS tracking, route optimization, multi-shift support, and reliable scheduling for efficient employee movement."
  },
  {
    "name": "Industrial Transport Uluberia",
    "description": "Industrial Transport Uluberia provides comprehensive transport services for factories and industrial units, supporting bulk staff movement, multi-shift operations, and safe, punctual travel for employees across Uluberia Industrial Park."
  },
  {
    "name": "Corporate Fleet Uluberia",
    "description": "Corporate Fleet Uluberia offers fleet management services including vehicle maintenance, driver management, route planning, and scalable corporate transport for companies operating in Uluberia Industrial areas."
  }
],

"tableData": [
  ["Uluberia Industrial Cab", "Corporate Shuttle Uluberia"],
  ["Employee Transport Uluberia", "Staff Pickup Drop Uluberia Industrial Park"],
  ["Monthly Cab Uluberia", "Business Cab Uluberia"],
  ["Affordable Cab Uluberia", "Best Corporate Cab Uluberia"],
  ["Outstation Cab Uluberia", "Sedan Cab Uluberia"],
  ["SUV Cab Uluberia", "Company Transport Uluberia"],
  ["Employee Mobility Uluberia", "Industrial Transport Uluberia"],
  ["Corporate Fleet Uluberia", ""]
],


  





"whychoose": [
  {
    "WhyChooseheading": "Corporate Cab Service in Uluberia Industrial Park",
    "WhyChoosedescription": "Pune Corporate Cars India Private Limited provides reliable corporate cab services in Uluberia Industrial Park, ensuring smooth and efficient transportation for employees and business executives across the industrial zone."
  },
  {
    "WhyChooseheading": "Timely Pickups & Drop-offs",
    "WhyChoosedescription": "We offer punctual pickups and drop-offs across Uluberia Industrial Park, helping employees reach factories, offices, and meetings on time."
  },
  {
    "WhyChooseheading": "Professional & Experienced Drivers",
    "WhyChoosedescription": "Our trained chauffeurs ensure safe, courteous, and disciplined travel, providing a secure and comfortable commute for corporate clients."
  },
  {
    "WhyChooseheading": "Well-Maintained Vehicle Fleet",
    "WhyChoosedescription": "Choose from sedans, SUVs, tempo travellers, and buses—all sanitized, serviced, and maintained for reliable and comfortable corporate travel in Uluberia Industrial Park."
  },
  {
    "WhyChooseheading": "Customized Corporate Travel Packages",
    "WhyChoosedescription": "We offer flexible and tailored cab rental plans to meet the commuting requirements of companies and employees in Uluberia Industrial Park."
  },
  {
    "WhyChooseheading": "24/7 Corporate Travel Support",
    "WhyChoosedescription": "Our team provides round-the-clock assistance for bookings, emergencies, and route adjustments, ensuring uninterrupted corporate transportation."
  },
  {
    "WhyChooseheading": "Safe & Hygienic Rides",
    "WhyChoosedescription": "All vehicles are sanitized regularly and equipped with modern safety features, offering secure and comfortable rides for employees and executives."
  },
  {
    "WhyChooseheading": "Efficient Booking & Coordination",
    "WhyChoosedescription": "Corporate travel is streamlined through our easy booking system and reliable coordination, making employee transport hassle-free."
  }
]
















  }

  
const faqData = [
  {
    question: 'Do you provide corporate cab services in Uluberia Industrial Park?',
    answer: 'Yes, Pune Corporate Cars India Private Limited offers reliable and professional corporate cab services for companies and industrial offices in Uluberia Industrial Park.',
  },
  {
    question: 'What types of corporate transportation services are available in Uluberia Industrial Park?',
    answer: 'We provide employee transportation, industrial shuttle services, corporate pickups and drops, airport transfers, and complete fleet management for corporate and industrial clients.',
  },
  {
    question: 'Do you support daily employee commute services in Uluberia Industrial Park?',
    answer: 'Yes, we offer structured daily commute solutions with optimized routes, timely pickups, and multi-shift support for employees.',
  },
  {
    question: 'How can companies book corporate cab services in Uluberia Industrial Park?',
    answer: 'Companies can book through our website, mobile app, or by contacting our 24×7 dedicated corporate support team.',
  },
  {
    question: 'Which vehicles are available for corporate cab services in Uluberia Industrial Park?',
    answer: 'We offer hatchbacks, sedans, SUVs, Innova Crysta, tempo travellers, luxury cars, and electric vehicles based on corporate requirements.',
  },
  {
    question: 'Do you offer long-term corporate cab contracts in Uluberia Industrial Park?',
    answer: 'Yes, we provide monthly, quarterly, and annual corporate transportation contracts with flexible pricing and comprehensive fleet management.',
  },
  {
    question: 'Are your vehicles equipped with GPS and safety features?',
    answer: 'All vehicles are GPS-enabled, regularly sanitized, and driven by trained and background-verified chauffeurs to ensure employee safety.',
  },
  {
    question: 'Do you provide transportation for night shifts and rotational shifts in Uluberia Industrial Park?',
    answer: 'Absolutely. We provide reliable transport solutions for night shifts, early morning shifts, weekend operations, and rotational schedules.',
  },
  {
    question: 'What payment options are available for corporate cab services?',
    answer: 'We accept UPI, bank transfers, credit/debit cards, digital wallets, and provide consolidated monthly corporate invoicing.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Abhijit Roy',
    feedback: 'Dependable corporate cab service for our Uluberia Industrial Park office. Vehicles are well-maintained and drivers are professional.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Tanushree Ghosh',
    feedback: 'Excellent service for corporate commutes. Timely pickups, smooth rides, and courteous drivers make it a perfect choice.',
    rating: 5,
  },
];












































































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Corporate Cab Services in Pune", link: "corporate-cab-services-in-pune" },
{ place: "/images/keyword/2.jpg", text: "Monthly Cab Services in Pune", link: "monthly-cab-services-in-pune" },
{ place: "/images/keyword/3.jpg", text: "Corporate Car Rental in Pune", link: "corporate-car-rental-in-pune" },
{ place: "/images/keyword/4.jpg", text: "Corporate Car Rentals Services in Pune", link: "corporate-car-rentals-services-in-pune" },
{ place: "/images/keyword/5.jpg", text: "Corporate cab services for Pune Outstation", link: "corporate-cab-services-for-pune-outstation" },
{ place: "/images/keyword/6.jpg", text: "Corporate Cab Service in Kharadi", link: "corporate-cab-service-in-kharadi" },
{ place: "/images/keyword/7.jpg", text: "Corporate Cab Service in Hadapsar", link: "corporate-cab-service-in-hadapsar" },
{ place: "/images/keyword/8.jpg", text: "Corporate Cab Service in Viman Nagar", link: "corporate-cab-service-in-viman-nagar" },
{ place: "/images/keyword/9.jpg", text: "Monthly Pick and Drop Service Pune", link: "monthly-pick-and-drop-service-pune" },
{ place: "/images/keyword/10.jpg", text: "Corporate Cab Services in Hinjewadi", link: "corporate-cab-services-in-hinjewadi" },
{ place: "/images/keyword/11.jpg", text: "Corporate Cab Service in Talegaon MIDC", link: "corporate-cab-service-in-talegaon-midc" },
{ place: "/images/keyword/12.jpg", text: "Corporate Cab Services in Chakan MIDC", link: "corporate-cab-services-in-chakan-midc" },
{ place: "/images/keyword/13.jpg", text: "Corporate Cab Services in Talawade MIDC", link: "corporate-cab-services-in-talawade-midc" },
{ place: "/images/keyword/14.jpg", text: "Cab Service for IT Company in Pune", link: "cab-service-for-it-company-in-pune" },
{ place: "/images/keyword/15.jpg", text: "Corporate Cab Services in Bhosari MIDC", link: "corporate-cab-services-in-bhosari-midc" },
{ place: "/images/keyword/16.jpg", text: "Office Pickup and Drop Service in Pune", link: "office-pickup-and-drop-service-in-pune" },
{ place: "/images/keyword/17.jpg", text: "Corporate Cabs Services in Sanaswadi", link: "corporate-cabs-services-in-sanaswadi" },
{ place: "/images/keyword/18.jpg", text: "Corporate Cab Services in Ranjangaon MIDC", link: "corporate-cab-services-in-ranjangaon-midc" },
{ place: "/images/keyword/19.jpg", text: "Corporate Cab Services in Karegaon MIDC", link: "corporate-cab-services-in-karegaon-midc" },
{ place: "/images/keyword/20.jpg", text: "Corporate Cab Services in Shirwal MIDC", link: "corporate-cab-services-in-shirwal-midc" },
{ place: "/images/keyword/21.jpg", text: "Corporate Cab Services in Shikrapur MIDC", link: "corporate-cab-services-in-shikrapur-midc" },
{ place: "/images/keyword/22.jpg", text: "Cab Service in Jejuri MIDC", link: "cab-service-in-jejuri-midc" },
{ place: "/images/keyword/23.jpg", text: "Best Cab Service for Corporate Employees Pune", link: "best-cab-service-for-corporate-employees-pune" },
{ place: "/images/keyword/24.jpg", text: "Corporate Travel Companies in Pune", link: "corporate-travel-companies-in-pune" },
{ place: "/images/keyword/25.jpg", text: "Innova Crysta Hire for Corporate Events in Pune", link: "innova-crysta-hire-for-corporate-events-in-pune" }
  ];












const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Corporate Cab Service in Uluberia Industrial Park",
  "image": "https://www.punecorporatecars.com/assets/images/corporate-cab-uluberia.jpg", // replace with actual image URL
  "description":
    "Pune Corporate Cars India Private Limited provides reliable corporate cab services in Uluberia Industrial Park, including industrial cabs, corporate shuttle, employee transport, staff pickup & drop, monthly corporate cabs, business cabs, affordable and executive cabs, outstation trips, sedan & SUV corporate cabs, company transport, employee mobility solutions, industrial transport, and complete corporate fleet management.",
  "brand": {
    "@type": "Brand",
    "name": "Pune Corporate Cars India Private Limited"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "ratingCount": "5800",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2400",
    "availability": "https://schema.org/InStock",
    "url": "https://www.punecorporatecars.com/corporate-cab-uluberia-industrial-park"
  }
};





  return (
    <div>
<Helmet>
  <title>Corporate Cab Service in Uluberia Industrial Park | Employee & Industrial Transport</title>

  <meta
    name="description"
    content="Reliable corporate cab services in Uluberia Industrial Park including industrial cabs, corporate shuttle, employee transport, staff pickup & drop, monthly corporate cabs, business cabs, affordable and executive cabs, outstation trips, sedan & SUV corporate cabs, company transport, employee mobility solutions, industrial transport, and corporate fleet management."
  />

  <meta
    name="keywords"
    content="Uluberia Industrial Cab, Corporate Shuttle Uluberia, Employee Transport Uluberia, Staff Pickup Drop Uluberia Industrial Park, Monthly Cab Uluberia, Business Cab Uluberia, Affordable Cab Uluberia, Best Corporate Cab Uluberia, Outstation Cab Uluberia, Sedan Cab Uluberia, SUV Cab Uluberia, Company Transport Uluberia, Employee Mobility Uluberia, Industrial Transport Uluberia, Corporate Fleet Uluberia"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

      <section
        className="breadcrumb-section"
        style={{ backgroundImage: "url(/images/background/inner-banner-bg.jpg)" }}
      >
        <div className="container">
          <div className="banner-content">
            <h1>{cardData.keyword}</h1>
          </div>
        </div>
      </section>













      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/94.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Pune Corporate Company</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Pune Corporate Company </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919822136667" className="pc-call">+91 9822136667</a>
                      <a href="tel:+917350959600" className="pc-call">+91 7350959600</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919822136667"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919822136667" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:sanjay.nalawade@punecorporatecars.com" className="pc-email">
                      sanjay.nalawade@punecorporatecars.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                     <strong>Pune Corporate Company</strong><br />
                      Gate No 124/2/1 Plot No 86 Vishva Vilas City
Lane No 08 Khandave Nagar Nagar Road Lohgaon
Haveli, Pune 412207 Maharashtra, India
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Corporatecabserviceinulubeniriaindustrialpark;